
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurar-clave",
      function () {
        return require("private-next-pages/restaurar-clave/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/restaurar-clave"])
      });
    }
  